import { render, staticRenderFns } from "./PrintIndex.vue?vue&type=template&id=500ba4b0&scoped=true&"
import script from "./PrintIndex.vue?vue&type=script&lang=js&"
export * from "./PrintIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500ba4b0",
  null
  
)

export default component.exports